import {forwardRef, useCallback, useEffect, useImperativeHandle, useRef} from "react";
import {SLowcodeList} from "shj-components";
import {config} from "./config.tsx";
import {queryClueEmployeeForReassign} from "@/services/callCenter";
import {apiData2Table} from "@/utils/data.ts";
import {getRoleListFn} from "@/services/member.ts";

export const ChooseList = forwardRef((props, ref) => {
  const listRef = useRef()
  const {editId, id, updateSelectedObj, rows, fetchApi = queryClueEmployeeForReassign} = props
  useEffect(() => {
    // if(editId && id) fetchList()
    console.log('getId--->111', id)

  }, [editId, id]);

  const fetchList = useCallback(({current, pageSize, query}) => {
    console.log('getId--->', id)
    if (!id && !editId) return Promise.reject()
    return new Promise((resolve, reject) => {
      console.log(current, pageSize, query)
      fetchApi({trackPlanNodeId: id, clueId: editId, ...query}, {pageId: current, pageSize}).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }, [id, editId])

  useImperativeHandle(ref, () => {
    return {
      getRows: () => {
        const [_, selectedRows] = listRef.current?.getSelectedRows();
        return selectedRows
      }
    }
  }, [])

  const getStatusOptions = async () => {
    const roleList = await getRoleListFn({ data: {  } })
    return Promise.resolve({roleList})
  }

  const extension = {
    request: {fetchList, getStatusOptions},
    rowSelection: {
      onChange: (_, selectedRows) => {
        updateSelectedObj(selectedRows)
      }
    },
    selectedRows: rows,
  }

  return <SLowcodeList
      ref={listRef}
      searchMode={'group'}
      {...extension}
      config={{...config}}/>
})